import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { shark } from '@ifit/base-coat/js/colors';
import './index.scss';

interface IProps {
  color?: string;
  size?: number;
  className?: string;
}

export default function DotsLoading({
  color = shark,
  size = 8,
  className = '',
  ...rest
}: IProps): ReactElement {
  const styles = {
    background: color,
    height: `${size}px`,
    margin: `0 ${size / 2}px`,
    width: `${size}px`,
  };

  return (
    <div
      className={classnames('mp-dots-loading', className)}
      data-testid="mp-dots-loading"
      {...rest}
    >
      <span className="mp-loading-dot" style={styles} />
      <span className="mp-loading-dot" style={styles} />
      <span className="mp-loading-dot" style={styles} />
    </div>
  );
}
